class MockHelper {
  static mockPromiseListRequest(resolveData) {
    return new Promise((resolve, reject) => {
      resolve({
        data: {
          content: resolveData,
          total: resolveData.length,
        },
      });
      reject();
    });
  }

  static mockPromiseGetRequest(resolveData) {
    return new Promise((resolve, reject) => {
      resolve({
        data: {
          ...resolveData,
        },
      });
      reject();
    });
  }

  static mockPromiseSaveEditOrRemoveRequest() {
    return new Promise((resolve, reject) => {
      resolve();
      reject();
    });
  }

  static mockPromiseGetFileRequest() {
    return new Promise((resolve, reject) => {
      const blob = new Blob([''], { type: 'text/html' });
      blob.lastModifiedDate = '';
      blob.name = 'filename';
      resolve(blob);
      reject();
    });
  }
}

export default MockHelper;
